var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"verify-button"},[_c('p',[_vm._v(_vm._s(_vm.appIp)+"用户,请完成安全验证")]),_vm._v(" "),_c('button',{on:{"click":_vm.getVerify}},[_vm._v("点击去完成")])])}
var staticRenderFns = []

export { render, staticRenderFns }